var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 27.3333C6.64897 27.3333 0.666748 21.3511 0.666748 14C0.666748 6.64889 6.64897 0.666672 14.0001 0.666672C21.3512 0.666672 27.3334 6.64889 27.3334 14C27.3334 21.3511 21.3512 27.3333 14.0001 27.3333ZM14.0001 1.93778C7.36008 1.93778 1.96008 7.34667 1.96008 14C1.96008 20.6533 7.36008 26.0622 14.0001 26.0622C20.6401 26.0622 26.0401 20.6489 26.0401 14C26.0401 7.35112 20.6401 1.93778 14.0001 1.93778Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1735 23.1289C13.8047 23.1289 13.5069 22.8311 13.5069 22.4622V14.4133H11.5824C11.2135 14.4133 10.9158 14.1155 10.9158 13.7466C10.9158 13.3777 11.2135 13.08 11.5824 13.08H14.1735C14.5424 13.08 14.8402 13.3777 14.8402 13.7466V22.4622C14.8402 22.8311 14.5424 23.1289 14.1735 23.1289Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5558 11.0445C12.098 11.0445 10.9158 9.8578 10.9158 8.40446C10.9158 6.95113 12.1024 5.76447 13.5558 5.76447C15.0091 5.76447 16.1958 6.95113 16.1958 8.40446C16.1958 9.8578 15.0091 11.0445 13.5558 11.0445ZM13.5558 7.0978C12.8358 7.0978 12.2491 7.68447 12.2491 8.40446C12.2491 9.12446 12.8358 9.71113 13.5558 9.71113C14.2758 9.71113 14.8624 9.12446 14.8624 8.40446C14.8624 7.68447 14.2758 7.0978 13.5558 7.0978Z",
    fill: "#C18344"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.c33c039cc5c3b6231051ec195a3902d4.svg";
export { ForwardRef as ReactComponent };